import { render } from "./Spinner.vue?vue&type=template&id=be7ae584"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=be7ae584&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__